import Alert from './Alert'

export default class Warning extends Alert {
  constructor(title,text) {
    super('warning',title,text)
  }
}